<template>
  <header class="nav-bar-container">
    <div class="nav-bar-content">
      <img
        class="logo"
        src="@/assets/images/logo.png"
        alt="微牛网址管理平台"
      >

      <nav class="right-panel">
        <div
          v-for="(item, index) in list"
          :key="item.className"
          class="nav-item"
          :class="{ 'nav-item--active': currentClass == index }"
          @click="changeClass(index)"
        >
          {{ item.className }}
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    data() {
      return {
        list: urlData.filter((item) => !item.hide),
      }
    },
    computed: {
      ...mapState(['currentClass']),
    },
    methods: {
      changeClass(i) {
        this.$store.commit('setCurrentClass', i)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .nav-bar-container {
    z-index: 99;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 60px;
    background: rgba(16, 21, 31, 0.82);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.07);

    .nav-bar-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 24px;
      max-width: 1280px;
      height: 100%;
      padding: 0 24px;
      margin: auto;

      .logo {
        flex-shrink: 0;
        width: 170px;
      }

      .right-panel {
        display: flex;
        align-items: center;
        gap: 6px;
        overflow-x: auto;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }

        .nav-item {
          flex-shrink: 0;
          padding: 8px 16px;
          border-radius: 8px;
          font-size: 14px;
          color: #9aa4b5;
          white-space: nowrap;
          cursor: pointer;
          transition: color 0.25s, background 0.25s;

          &:hover {
            color: #fff;
          }

          &--active {
            background: rgba(252, 110, 62, 0.14);
            color: #ff8b60;
            font-weight: 600;

            &:hover {
              color: #ff8b60;
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 640px) {
    .nav-bar-container .nav-bar-content {
      gap: 12px;
      padding: 0 16px;

      .logo {
        width: 130px;
      }
    }
  }
</style>
